import { render, staticRenderFns } from "./rightController.vue?vue&type=template&id=038e42e6&"
import script from "./rightController.vue?vue&type=script&lang=ts&"
export * from "./rightController.vue?vue&type=script&lang=ts&"
import style0 from "./rightController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports